"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsDropZoneWithBrowseFileAccessValid = exports.getIsConfigureFileManagerFileAccessValid = exports.getIsDrawerFileAccessValid = exports.getIsDropZoneNoBrowseFileAccessValid = void 0;

var _FileAccess = require("../enums/FileAccess");

var getIsFileAccessValidByType = function getIsFileAccessValidByType(uploadedFileAccess, FileAccessEnum) {
  return Object.keys(FileAccessEnum).includes(uploadedFileAccess);
};

var getIsDropZoneNoBrowseFileAccessValid = function getIsDropZoneNoBrowseFileAccessValid(uploadedFileAccess) {
  return getIsFileAccessValidByType(uploadedFileAccess, _FileAccess.DropZoneNoBrowseFileAccess);
};

exports.getIsDropZoneNoBrowseFileAccessValid = getIsDropZoneNoBrowseFileAccessValid;

var getIsDrawerFileAccessValid = function getIsDrawerFileAccessValid(uploadedFileAccess) {
  return getIsFileAccessValidByType(uploadedFileAccess, _FileAccess.DrawerFileAccess);
};

exports.getIsDrawerFileAccessValid = getIsDrawerFileAccessValid;
var getIsConfigureFileManagerFileAccessValid = getIsDrawerFileAccessValid;
exports.getIsConfigureFileManagerFileAccessValid = getIsConfigureFileManagerFileAccessValid;

var getIsDropZoneWithBrowseFileAccessValid = function getIsDropZoneWithBrowseFileAccessValid(uploadedFileAccess) {
  return getIsFileAccessValidByType(uploadedFileAccess, _FileAccess.DropZoneWithBrowseFileAccess);
};

exports.getIsDropZoneWithBrowseFileAccessValid = getIsDropZoneWithBrowseFileAccessValid;